import { createReducer, on } from '@ngrx/store';

import { LoadingState, Logout } from '@personal-area/global/state';

import { CardVerificationResponse } from '../../models/card-verification-response';
import * as cardActions from '../actions/card';

export type CardState = CardVerificationResponse & {
  loadingState: LoadingState;
};

const initialState: CardState = {
  card: '',
  loadingState: LoadingState.initial,
};

export const cardReducer = createReducer(
  initialState,
  on(cardActions.GetCard, (state) => ({
    ...state,
    loadingState: LoadingState.loading,
  })),
  on(cardActions.GetCardSuccess, (state, { card }) => ({
    card: card,
    loadingState: LoadingState.loaded,
  })),
  on(cardActions.GetCardFail, (state) => ({
    ...state,
    loadingState: LoadingState.failed,
  })),
  on(Logout, (state) => initialState),
);
